// @ts-check
import configClient from "../../../api/hooks/config-client"
export const title = "SFU"

let _apiBaseURL = typeof window !== "undefined" && window.localStorage?.getItem("apiBase")
// Fallback-Domain für SSR: echte Produktionsdomain
const domain = "familienunternehmen-politik.de"
export const baseDomain = typeof window !== "undefined" ? document?.location?.hostname : domain
export const baseURL = "https://" + baseDomain
export const apiBaseURL = _apiBaseURL || configClient.apiClientBaseURL
export let languages = {
    de: "Deutsch",
    en: "English",
}
export const mail = "info@familienunternehmen-politik.de"
export const socialMedia = {
    linkedIn: "https://www.linkedin.com/company/stiftung-familienunternehmen-und-politik/",
    x: "https://x.com/stiftungfampol?lang=de",
    instagram: "https://www.instagram.com/familienunternehmen_politik/",
}
export const animationsAllowed = typeof window !== "undefined" && "IntersectionObserver" in window
export let anime: any
if (typeof window !== "undefined") {
    // wird auf dem Server nie ausgeführt
    anime = require("animejs")
}
type Target = string | Element | Element[] | NodeListOf<Element>

const paramsMap = new Map<Element, any>()
let io: IntersectionObserver

function getObserver(): IntersectionObserver {
    if (io) return io
    io = new IntersectionObserver(
        (entries) => {
            entries.forEach(({ isIntersecting, target }) => {
                if (isIntersecting && paramsMap.has(target as Element)) {
                    const params = paramsMap.get(target as Element)!
                    anime.animate(target as Element, params)
                    io.unobserve(target)
                    paramsMap.delete(target as Element)
                }
            })
        },
        {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: 0,
        }
    )
    return io
}

export function animateOnVisible(targets: Target, params: any): void {
    let elements: Element[]

    if (typeof targets === "string") {
        elements = Array.from(document.querySelectorAll(targets))
    } else if (NodeList.prototype.isPrototypeOf(targets)) {
        elements = Array.from(targets as NodeListOf<Element>)
    } else if (Array.isArray(targets)) {
        elements = targets
    } else {
        elements = [targets]
    }

    elements.forEach((el) => {
        if (!el) return

        // initial styles
        const { opacity, translateY, translateX, translate, scale } = params
        if (Array.isArray(opacity)) el.style.opacity = opacity[0].toString()

        let tx = "0",
            ty = "0"
        if (Array.isArray(translateY)) ty = translateY[0].toString()
        if (Array.isArray(translateX)) tx = translateX[0].toString()
        if (Array.isArray(translate)) {
            tx = translate[0].toString()
            ty = "0"
        }
        if (translateY || translateX || translate) {
            el.style.transform = `translateX(${tx}) translateY(${ty})`
        }
        if (Array.isArray(scale)) {
            const prev = el.style.transform || ""
            el.style.transform = `${prev} scale(${scale[0]})`
        }

        // register for intersection
        paramsMap.set(el, params)
        getObserver().observe(el)
    })
}
